
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  resetPasswordChangeFormButton: {
    id: "ResetPasswordChangeForm.button",
    defaultMessage: "Reset password",
  },
});

export default MESSAGES;